import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_EditorContent = _resolveComponent("EditorContent");
    return (_openBlock(), _createElementBlock("div", {
        ref: "editorContainer",
        class: _normalizeClass([
            'table-editor-container',
            {
                'no-border': _ctx.borderColor === _ctx.Colors.Transparent,
                'alternate-row-color': _ctx.alternateRowColor === _ctx.Colors.Gray,
                'header-row-background-color': _ctx.headerRowBackgroundColor === _ctx.Colors.Gray,
                overflow: _ctx.overflow,
            },
        ])
    }, [
        _createVNode(_component_EditorContent, {
            editor: _ctx.viewer,
            spellcheck: "false"
        }, null, 8, ["editor"])
    ], 2));
}
